class S71Gallery extends HTMLElement {
  constructor() {
    super();
    this.row = this.querySelector('[data-s71-gallery-row]');
    this.pointerDown = this.pointerDown.bind(this);
    this.pointerMove = this.pointerMove.bind(this);
    this.pointerUp = this.pointerUp.bind(this);
  }

  connectedCallback() {
    if (!this.row) return;
    if (!window.matchMedia('(pointer: fine)').matches) return;

    this.classList.add('s71-gallery--draggable');
    this.row.addEventListener('pointerdown', this.pointerDown);
  }

  disconnectedCallback() {
    this.row?.removeEventListener('pointerdown', this.pointerDown);
    this.stop();
  }

  pointerDown(event) {
    if (event.button !== 0) return;

    this.startX = event.clientX;
    this.startScroll = this.row.scrollLeft;
    this.moved = false;
    this.pointerId = event.pointerId;

    window.addEventListener('pointermove', this.pointerMove);
    window.addEventListener('pointerup', this.pointerUp);
    window.addEventListener('pointercancel', this.pointerUp);
  }

  pointerMove(event) {
    const delta = event.clientX - this.startX;

    if (!this.moved && Math.abs(delta) > 4) {
      this.moved = true;
      this.classList.add('s71-gallery--dragging');
      this.row.setPointerCapture?.(this.pointerId);
    }

    if (!this.moved) return;
    event.preventDefault();
    this.row.scrollLeft = this.startScroll - delta;
  }

  pointerUp(event) {
    if (this.moved) {
      const swallowClick = (e) => e.preventDefault();
      this.row.addEventListener('click', swallowClick, { capture: true, once: true });
      setTimeout(() => this.row.removeEventListener('click', swallowClick, { capture: true }), 0);
      this.row.releasePointerCapture?.(event.pointerId);
    }
    this.stop();
  }

  stop() {
    this.classList.remove('s71-gallery--dragging');
    window.removeEventListener('pointermove', this.pointerMove);
    window.removeEventListener('pointerup', this.pointerUp);
    window.removeEventListener('pointercancel', this.pointerUp);
  }
}

customElements.define('s71-gallery', S71Gallery);
